// REPORTING DETAILS
export const GET_REPORTING_DETAILS_START = 'GET_REPORTING_DETAILS_START';
export const GET_REPORTING_DETAILS_COMPLETE = 'GET_REPORTING_DETAILS_COMPLETE';
export const GET_REPORTING_DETAILS_FAILURE = 'GET_REPORTING_DETAILS_FAILURE';

export function fetchReportingDetails() {
  return { type: GET_REPORTING_DETAILS_START };
}

